import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AppModuleTenantName, ITenantTemplateConfig } from '@warema/shared/models';
import { TenantConfigurationService } from '@warema/shared/tenant-config';

export const tenantGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const tenantConfig = inject(TenantConfigurationService);

    const moduleName = route.data['moduleName'] as AppModuleTenantName;
    const moduleSettings = (tenantConfig.settings as unknown as Record<string, unknown> | null)?.[
        moduleName
    ] as ITenantTemplateConfig;
    const isModuleEnabled = moduleSettings?.enabled;
    if (!isModuleEnabled) {
        void router.navigate(['/']);
    }
    return isModuleEnabled;
};
